'use client'

import React from 'react'
import { ModuleRegistry } from '@ag-grid-community/core'
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model'

import { AGGridCore } from '@fsg/gui-bits'
import { AGGridWrapperProps } from '@gui/types'

if (typeof window !== 'undefined') {
  ModuleRegistry.registerModules([ServerSideRowModelModule])
}

export function AGGridServerSide<ContextType>(props: AGGridWrapperProps) {
  return <AGGridCore<ContextType> {...props} />
}
